import React , {useState}from 'react';
import './App.css';


import './styles.css'



import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from './Components/Header/Header';
import Campain from './Components/Header/Campains/Campain';
import Horarrios from './Components/Horarios/Horarrios';
import About from './Components/About/About';
import Clientes from './Components/Clientes/Clientes';
import Login from './Components/Login/Login';
import CampainSetUp from './Components/Header/Campains/CampainSetUp';
import MessagesSent from './Components/Messages/MessagesSent';

function App() {

  const [clearLogin,setClearLogin] = useState(true);

  function onClear() {
    localStorage.clear();

    setClearLogin(true)

  }
  return (

  

    <BrowserRouter>
    <div className="w-100" >

      {!clearLogin && <Login clear={onClear}></Login> }
      
      
      {/*<Header></Header>*/}
    </div>

    <Routes>
        <Route path="/" element={<Login  clear={onClear} />} />
        <Route path="/header" element={<Header />} />
        <Route path="/campains" element={<Campain />} />
        <Route path="/clientes" element={<Clientes />} />
        <Route path="/horarios" element={<Horarrios />} />
        <Route path="/campainsetup" element={<CampainSetUp />} />
        <Route path="/sentmessages" element={<MessagesSent />} />
        {/*<Route path="/login" element={<Login />} />*/}
        <Route path="/about" element={<About />} />


    </Routes>

  </BrowserRouter>

  );
}

export default App;
